"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.customEngineAgentNode = void 0;
const localizeUtils_1 = require("../../../common/localizeUtils");
const questionNames_1 = require("../../questionNames");
const CapabilityOptions_1 = require("./CapabilityOptions");
const ProjectTypeOptions_1 = require("./ProjectTypeOptions");
const teamsProjectTypeNode_1 = require("./teamsProjectTypeNode");
function customEngineAgentNode() {
    return {
        // project-type = Custom Engine Agent
        condition: { equals: ProjectTypeOptions_1.ProjectTypeOptions.customEngineAgentOptionId },
        data: {
            name: questionNames_1.QuestionNames.Capabilities,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.customCopilot.title"),
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.CustomEngineAgentOptions.basicCustomEngineAgent(),
                CapabilityOptions_1.CustomEngineAgentOptions.weatherAgent(),
            ],
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.customCopilot.placeholder"),
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [(0, teamsProjectTypeNode_1.llmServiceNode)()],
    };
}
exports.customEngineAgentNode = customEngineAgentNode;
//# sourceMappingURL=customEngineAgentNode.js.map